import React from "react";
import "../../Css/Worldwidemandals.css";

function Worldwidemandals() {
  return (
    <section className="about-section">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 Full_width">
            <iframe
              style={{ width: "850px", height: "1500px" }}
              src="https://docs.google.com/document/d/e/2PACX-1vREIhAELbbUsHvCjOZ2dn5zm1QRMKCgxPNfKufy3_OMTytwOo0Peaj6nWLDEN0kjSnrUS1Yc8slG8yD/pub?embedded=true"
              title="Google Document"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Worldwidemandals;
